// extracted by mini-css-extract-plugin
module.exports = {"photo":"AddPhotoControl_photo__3NddG","photoSelector":"AddPhotoControl_photoSelector__qQbc6","wrapper":"AddPhotoControl_wrapper__25wfM","delete":"AddPhotoControl_delete__2p8bH"};